export default __webpack_public_path__ + "static/woman1-f4a5a8b48b2240bd42082bb2fde03635.png";